module.exports = __webpack_public_path__ + "static/media/DZ.4450a753.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/DZ.svg
// module id = 2142
// module chunks = 7